import { useStore } from './store';

export function showToast(message: string): void {
  useStore.setState({ toast: { message, visible: true } });
  setTimeout(() => {
    useStore.setState((state) => {
      if (state.toast.message === message) {
        return { toast: { ...state.toast, visible: false } };
      }
      return {};
    });
  }, 2000);
}
